import { render, staticRenderFns } from "./OrganizeProducts.vue?vue&type=template&id=b3dd4548&scoped=true&"
import script from "./OrganizeProducts.vue?vue&type=script&lang=js&"
export * from "./OrganizeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dd4548",
  null
  
)

export default component.exports